module.exports = "<xo-generic-message token=token></xo-generic-message>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-generic-message/template.html
 ** module id = 217
 ** module chunks = 1
 **/